export default __webpack_public_path__ + "static/media/locker-icon.f7a8df58.svg";